import { OrderStatus } from '../../shared/models';

// iOS TimeFrame enum (Models/TimeFrame.swift)
export const TIME_FILTERS = ['Day', 'Week', 'Month', 'Year'];

// iOS RestaurantOrderFilterTabs.restaurantStatuses — also used as the
// pending-first sort priority in RestaurantOrdersSection.filteredOrders.
export const STATUS_FILTERS = [
  OrderStatus.PENDING,
  OrderStatus.CONFIRMED,
  OrderStatus.PREPARING,
  OrderStatus.READY,
  OrderStatus.COMPLETED,
  OrderStatus.CANCELLED,
];

// iOS OrderStatus.restaurantColor (orange / indigo / mint / teal / green / red)
export const STATUS_CHIP_COLORS = {
  All: '#FF3B30',
  [OrderStatus.PENDING]: '#FF9500',
  [OrderStatus.CONFIRMED]: '#5856D6',
  [OrderStatus.PREPARING]: '#00C7BE',
  [OrderStatus.READY]: '#30B0C7',
  [OrderStatus.COMPLETED]: '#34C759',
  [OrderStatus.CANCELLED]: '#FF3B30',
};

const createdMs = (o) => (o.createdAt ? o.createdAt.getTime() : Date.now());

// Mirrors RestaurantOrderFilterTabs.filteredOrders(for:) —
// Day = today, Week = current calendar week (Sun–Sat), Month/Year = current period.
// Orders with a missing createdAt behave like the iOS parser default (Date() = now).
export function filterOrdersByTime(orders, timeFilter) {
  const now = new Date();
  return orders.filter((order) => {
    const d = order.createdAt || now;
    switch (timeFilter) {
      case 'Day':
        return d.getFullYear() === now.getFullYear()
          && d.getMonth() === now.getMonth()
          && d.getDate() === now.getDate();
      case 'Week': {
        const weekStart = new Date(now);
        weekStart.setHours(0, 0, 0, 0);
        weekStart.setDate(now.getDate() - now.getDay()); // en-US week starts Sunday
        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekStart.getDate() + 6);
        weekEnd.setHours(23, 59, 59, 999);
        return d >= weekStart && d <= weekEnd;
      }
      case 'Month':
        return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth();
      case 'Year':
        return d.getFullYear() === now.getFullYear();
      default:
        return true;
    }
  });
}

// Mirrors RestaurantOrdersSection.filteredOrders sorting:
// pending-first by status priority, then newest-first within each status.
// Statuses outside the restaurant list (Picked Up, In Delivery, …) sort last.
export function sortRestaurantOrders(orders, applyStatusPriority = true) {
  return [...orders].sort((a, b) => {
    if (applyStatusPriority) {
      const pa = STATUS_FILTERS.indexOf(a.status);
      const pb = STATUS_FILTERS.indexOf(b.status);
      const ia = pa === -1 ? Number.MAX_SAFE_INTEGER : pa;
      const ib = pb === -1 ? Number.MAX_SAFE_INTEGER : pb;
      if (ia !== ib) return ia - ib;
    }
    return createdMs(b) - createdMs(a);
  });
}
